import { render, staticRenderFns } from "./SchoolMapView.vue?vue&type=template&id=5567c421&"
import script from "./SchoolMapView.vue?vue&type=script&lang=js&"
export * from "./SchoolMapView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports